(function () {
  const locationsSelect = document.getElementById("locations-select");
  const allLocationsElements = document.querySelectorAll(".location-block");

  locationsSelect.addEventListener("change", () => {
    const selectValue = locationsSelect.value;
    allLocationsElements.forEach((locationBlock) => {
      if (selectValue === "all") {
        locationBlock.style.display = "block";
      } else {
        if (locationBlock.dataset.location !== selectValue) {
          locationBlock.style.display = "none";
        } else {
          locationBlock.style.display = "block";
        }
      }
    });
  });
})();